import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "./services/store";
import "./ui/global.scss";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Home } from "./ui/pages/home";
import ErrorScreen from "./ui/pages/error/error";

ReactDOM.render(
  <Provider>
    <React.StrictMode>
      <BrowserRouter>
        <Switch>
          <Route path="/" exact={true} component={Home} />
          <Route path="/desabilitado" exact={true} component={ErrorScreen} />
        </Switch>
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
